import { onClickOutside } from "../utils/onClickOutside"

const block = ".pop-up-banner"

const writeToTopLevelDom = (element) => {
  element.remove()
  document.body.appendChild(element)
  return element
}

const currentDate = new Date().toISOString()

export function PopupBanner() {
  const elements = document.querySelectorAll(block)

  elements.forEach((el) => {
    // Check if the banner should be displayed based on the start and end date
    const startDate = el.dataset.startDate

    if (startDate) {
      if (currentDate < startDate) {
        el.remove()
        return
      }
    }

    const endDate = el.dataset.endDate

    if (endDate) {
      if (currentDate > endDate) {
        el.remove()
        return
      }
    }
    // =============================================== //
    const id = el.id
    const lsKey = `popup-banner-${id}-seen`
    const popupBannerStored = localStorage.getItem(lsKey)

    let date

    if (popupBannerStored) {
      date = new Date(popupBannerStored)
    }

    if (date) {
      const diffTime = Math.abs(new Date(currentDate) - date)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      if (diffDays > 1) {
        localStorage.removeItem(lsKey)
      } else {
        el.remove()
        return
      }
    }

    // Move the element to the top level of the DOM
    const element = writeToTopLevelDom(el)
    const closeBtn = element.querySelector(`${block}__close-btn`)
    const contentEl = element.querySelector(`${block}__content`)

    const handleCloseClick = () => {
      element.remove()
      localStorage.setItem(lsKey, new Date().toISOString())
      closeBtn.removeEventListener("click", handleCloseClick)
    }

    onClickOutside(contentEl, handleCloseClick, null, true)

    const isHidden = element.classList.contains("hide")

    if (isHidden) {
      setTimeout(() => {
        element.classList.remove("hide")
        element.classList.add("show")
      }, 2000)
    }

    closeBtn.addEventListener("click", handleCloseClick, { once: true })
  })
}
